const CONSTANT = require('./shared/constants')
const savePageState = require('./modules/savePageState')
const restorePageState = require('./modules/restorePageState')
const installNavikStore = require('./store')

/**
 * Setups Navik inside an application.
 * Call this setup function inside a dedicated plugin from the application (see Readme).
 * @param {*} app
 * @param {*} inject
 */
const setup = (app, inject) => {
  const router = app.router

  router.afterEach((to, from) => {
    savePageState(router, to, from)
  })

  inject('navik', {
    restorePageState
  })

  installNavikStore(app.store)
}

module.exports = {
  CONSTANT,
  setup
}
